import { TimeFormatType } from './time-format-key'
import type { IResolvedTimeFormat } from './i-resolved-time-format'
import type { ITimePatterns } from './i-time-patterns'

export const TIME_FORMAT_PATTERNS: Record<IResolvedTimeFormat, ITimePatterns> = {
  [TimeFormatType.H24]: {
    timeOnly: 'HH:mm',
    shortWithSeconds: 'HH:mm:ss',
    hourOnly: 'HH',
  },
  [TimeFormatType.H12]: {
    timeOnly: 'h:mm A',
    shortWithSeconds: 'h:mm:ss A',
    hourOnly: 'h A',
  },
}
